import React from 'react';

export const Lila_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>Lila Downs ft. Juanes</span>,
  },
];

export const Thalia_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>Thalia</span>,
  },
];

export const Ana_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>Ana Torroja ft. Beto Cuevas</span>,
  },
];

export const Alessandra_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>Mario Domm - Alessandra Amoroso</span>,
  },
];

export const Beto_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>Beto Cuevas - Monsieur Periné</span>,
  },
];

export const Centro_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>Centro Cultural Coreano</span>,
  },
];
